import { useNavigate } from "react-router";

import { alertActions } from "../../../../features/alert/alertSlice";
import { useAppDispatch } from "../../../../hooks/reduxHooks";
import { deleteOrganization } from "../../../../lib/api";
import { ISponsor } from "../../../../types/api";

export const useFormHandlers = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const handleDelete = (id: ISponsor["id"]) => {
        deleteOrganization(id)
            .then(response => {
                dispatch(
                    alertActions.success({
                        level: "success",
                        title: response.message,
                        dismissible: true,
                        persist: true,
                    }),
                );
                navigate(`/league-management/organizations`);
            })
            .catch(error => {
                dispatch(
                    alertActions.error({
                        level: "danger",
                        title: "Deleting the organization failed with the following error:",
                        text:
                            error +
                            "\n\nIf the problem persists, please contact the site admin.",
                        dismissible: true,
                    }),
                );
            });
    };

    return { handleDelete };
};
